export default {"src":"/_next/static/media/no-result-paid.c06a1763.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};